// SETTINGS V2 atom — SComingPill. Dashed mono "coming soon" pill. Port of
// settings-kit.jsx SComingPill (lines 118-120). Caller translates the label
// (e.g. settings:profile.comingSoon) — atoms never call translate.
import React from "react";

export interface SComingPillProps {
  label: string;
}

const SComingPill: React.FC<SComingPillProps> = ({ label }) => (
  <span
    style={{
      fontFamily: "var(--font-mono)",
      fontSize: 9,
      letterSpacing: "0.07em",
      textTransform: "uppercase",
      color: "var(--faint)",
      border: "1px dashed var(--border)",
      borderRadius: 999,
      padding: "2px 8px",
      whiteSpace: "nowrap",
    }}
  >
    {label}
  </span>
);

export default SComingPill;
